<template>
  <section v-if="notice && notice.status !== 'anonymous'" class="account-notice" role="alertdialog" aria-modal="true" :aria-label="t('message.accountSessionTitle')">
    <div class="account-card">
      <h2>{{ t('message.accountSessionTitle') }}</h2>
      <p v-if="notice.accountName">{{ notice.accountName }}</p>
      <p>{{ t(`message.accountSession_${notice.status}`) }}</p>
      <p>{{ t('message.accountSessionConnection') }}</p>
      <div class="account-actions">
        <button :disabled="busy || notice.status === 'checking'" @click="notice.retry()">{{ t('message.accountSessionRetry') }}</button>
        <button :disabled="busy" @click="leave">{{ t('button.leave') }}</button>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { meetingAccountNotice as notice } from '@/utils/useMeetingAccount.js'
const { t } = useI18n()
const busy = ref(false)
async function leave() {
  if (busy.value) return
  busy.value = true
  try { await notice.value?.leave?.() } finally { busy.value = false }
}
</script>
<style scoped>
.account-notice { position: fixed; inset: 0; z-index: 10000; display: grid; place-items: center; background: rgb(0 0 0 / 70%); padding: 20px; color: #fff; }
.account-card { max-width: 560px; max-height: calc(100dvh - 40px); overflow: auto; padding: 24px; background: #202329; border: 1px solid #545860; border-radius: 8px; line-height: 1.6; }
.account-card h2 { margin-top: 0; font-size: 20px; }
.account-actions { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; }
.account-actions button, .account-actions a { color: #fff; background: #545860; border: 0; padding: 8px 14px; border-radius: 4px; font: inherit; cursor: pointer; }
.account-actions button:disabled { opacity: .5; cursor: wait; }
</style>
